import { render } from "./NewHeaderView.vue?vue&type=template&id=39be7a5b"
import script from "./NewHeaderView.vue?vue&type=script&lang=js"
export * from "./NewHeaderView.vue?vue&type=script&lang=js"

import "./NewHeaderView.vue?vue&type=style&index=0&id=39be7a5b&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__